var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPromotion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4386 3.24405L6.8946 5.9053C6.46793 6.1101 6.01203 6.16142 5.54729 6.0573C5.24314 5.98917 5.09105 5.9551 4.96858 5.94112C3.44786 5.76746 2.5 6.97105 2.5 8.35509V9.11464C2.5 10.4987 3.44786 11.7023 4.96858 11.5286C5.09105 11.5146 5.24315 11.4805 5.54729 11.4124C6.01203 11.3083 6.46793 11.3596 6.8946 11.5644L12.4386 14.2257C13.7112 14.8366 14.3475 15.142 15.057 14.9039C15.7664 14.6659 16.0099 14.1549 16.497 13.1332C17.8343 10.3275 17.8343 7.14224 16.497 4.3365C16.0099 3.31475 15.7664 2.80387 15.057 2.56578C14.3475 2.3277 13.7112 2.63315 12.4386 3.24405Z",
    stroke: "#F1F1F1",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.54846 18.1272L8.30566 19.1515C5.50434 16.9297 5.84657 15.8702 5.84657 11.6515H6.79143C7.17486 14.0356 8.07931 15.1648 9.32729 15.9823C10.096 16.4858 10.2545 17.5452 9.54846 18.1272Z",
    stroke: "#F1F1F1",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 11.2349V6.23486",
    stroke: "#F1F1F1",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromotion);
export default __webpack_public_path__ + "static/media/promotion.9f1f40c13a886201ae6e541e707f3b74.svg";
export { ForwardRef as ReactComponent };